import z from 'zod';
import {moduleTopicSchema} from '../examModule/moduleTopicSchema';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {questionStatusSchema} from './QuestionStatus';
import {questionReviewDbSchema} from './questionReviewDbSchema';

/**
 * Document shape as stored in Firestore: examModules/{moduleId}/questions/{questionId}.
 * id comes from document id when reading.
 */
export const questionDbSchema = z.object({
  moduleTopic: moduleTopicSchema,
  difficulty: z.number().int().min(1).max(5),
  questionText: z.string(),
  hint: z.string().optional(),
  options: z.array(z.string()),
  answer: z.string(),
  explanation: z.string(),
  createdAt: firestoreTimestampSchema,
  randomSeed: z.number().int().optional(),
  status: questionStatusSchema,
  statusNote: z.string().optional(),
  feedbackPositive: z.number().int().nonnegative().default(0),
  feedbackNegative: z.number().int().nonnegative().default(0),
  review: z.array(questionReviewDbSchema).optional(),
  imageUrl: z.string().optional(),
  graphJsonString: z.string().optional(),
  seedQuestionId: z.string().optional(),
});

export type QuestionDb = z.infer<typeof questionDbSchema>;
